<template>
    <div class="modal fade" id="viewExperienceletter">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printConfirmationletter()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printConfirmationletter">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>Experience Letter</strong></h4></td>
                          <td class="text-right" width="20%" v-if="seeRecord.user"><barcode v-bind:value="seeRecord.user.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <table class="table" v-if="seeRecord.user" >
                        <thead>
                          <td>
                            <b>
                              {{seeRecord.user.name}} <br>
                              <i>{{seeRecord.address}},</i><br> <i>{{seeRecord.city}},</i><i v-if="seeRecord.state">{{seeRecord.state.name}} -</i>  <i>{{seeRecord.pin}}</i><br>
                            </b>
                          </td>
                          <td class="text-right" v-if="seeRecord.branch">Branch: {{seeRecord.branch.name}} <br>Date: {{currDate | myDate}}</td>
                        </thead>
                      </table>
                      <p class="text-center text-bold">TO WHOMSOEVER IT MAY CONCERN</p><br>
                      <!-- <p>Dear <b v-if="seeRecord.user">{{seeRecord.user.name}}</b></p> -->
                      <p>This is to certify that Mr/Ms. <b v-if="seeRecord.user">{{seeRecord.user.name}}</b> was in employment with us from {{periodStartDate | myDate}} to {{periodEndDate | myDate}}.  During this period, he/she was working as a <b v-if="seeRecord.designation">{{seeRecord.designation.name}}</b> and was based at <i v-if="seeRecord.branch">{{seeRecord.branch.address}}</i>. During his/her tenure with us we have found him/her to be sincere and hardworking with high integrity.</p>
                      <br>
                      
                      <p>We wish him/her all the best for his/her future endeavors.</p><br><br><br><br>
                      <p>Thanking you</p><br><br><br><br>
                      <p>Yours sincerely</p>
                      <p>Authorized Signatory</p>
                      <p>{{getCompanyRecord.companyName}}</p><br><br><br><br><br><br>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      currDate: new Date()
    }
  },
  methods: {
    printConfirmationletter () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printConfirmationletter').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    periodStartDate: '',
    periodEndDate: '',
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// ExperienceLetter.vue?26b03b2a